import '../../styles/AuthorItem.css';
import Icons from '../community/Icons';
import profileImage from '../../assets/images/community/author.jpeg';

function AuthorItem({ firstName, lastName }) {

    return (
        <div className='authorCard-item'>
            <div className='authorCard-item__description'>
                <div className='authorCard-item-image'>
                    <img src={profileImage} />
                </div>
            
                <h2>{firstName} {lastName}</h2>
            </div>
            <div>
                <Icons />
            </div>
        </div>
    );
}

export default AuthorItem;